import { render, staticRenderFns } from "./c_home_bargain.vue?vue&type=template&id=26754c72&scoped=true"
import script from "./c_home_bargain.vue?vue&type=script&lang=js"
export * from "./c_home_bargain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26754c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26754c72')) {
      api.createRecord('26754c72', component.options)
    } else {
      api.reload('26754c72', component.options)
    }
    module.hot.accept("./c_home_bargain.vue?vue&type=template&id=26754c72&scoped=true", function () {
      api.rerender('26754c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_bargain.vue"
export default component.exports